// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.loupe_color-picker_eydi8 {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 100%;
  border: 4px solid var(--ui-black-transparent);
}
`, "",{"version":3,"sources":["webpack://./src/components/loupe/loupe.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,6CAA6C;AAC/C","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.color-picker {\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 100%;\n  border: 4px solid var(--ui-black-transparent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `loupe_color-picker_eydi8`,
	"colorPicker": `loupe_color-picker_eydi8`
};
export default ___CSS_LOADER_EXPORT___;
